


























































































































































































































































import BaseComponent from '@/components/base-component.vue';
import ProductMaterial from '@/components/products/product-material.vue';
import UiFileUpload from '@/components/UI/file-upload.vue';
import InputMoney from '@/components/UI/input-money.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import { sortKey } from '@/helpers/sort';
import { toNumber } from '@/helpers/toNumber';
import { ID_UNIT_ML_DIA } from '@/interfaces/measurement-unit';
import { ICalorie, InsumoProdutoParmDTO, ProdutoParmDTO, ProdutoTipoPacConfigParmDTO } from '@/interfaces/product';
import { getSubgroups } from '@/services/groups';
import * as serviceMeasurementUnit from '@/services/measurement-unit';
import * as service from '@/services/products';
import { PDF_MIME_TYPES } from '@/settings/consts/file-upload';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import ListMessages from '../UI/list-messages.vue';
import TabContainerAlterHist from '../UI/tab-container-alter-hist.vue';
import ProductTpPatient from './product-tp-patient.vue';

@Component({
  components: {
    PermissionAuth,
    InputMoney,
    UiFileUpload,
    ProductMaterial,
    TabContainerAlterHist,
    ProductTpPatient,
    ListMessages
  }
})
export default class ProductForm extends BaseComponent {  
  @Prop()
  public id: number;

  @Prop()
  public isEdit: boolean;

  item: any = {
    idsUnidadesMedidas: [ID_UNIT_ML_DIA],
    insumos: new Array(),
    tipoPacConfigs: []
  };
  openDialog = false;

  histList = [];

  public form: any = {
    valid: false,
    rules: {
      code: [(v) => !!v || 'Coloque um código'],
      name: [(v) => !!v || 'Coloque um nome'],
      subgroup: [(v) => !!v || 'Selecione um subgrupo'],
      use: [(v) => !!v || 'Selecione ao menos um uso'],
      coloracao: [(v) => !!v || 'Selecione a coloração'],
      visibilidade: [(v) => !!v || 'Selecione a visibilidade'],
      measurement_units: [(v) => (!!v && !!v.length) || 'Selecione ao menos uma unidade de medida'],
      use_types: [(v) => this.checkUseTypes() || 'Selecione ao menos um uso'],
      calorieValue: [(v) => (!!v && !!toNumber(v)) || 'Digite o kcal/Grama da caloria selecionada.']
    }
  };

  checkUseTypes() {
    return (
      this.item && (this.item.usoPacienteAdulto || this.item.usoPacientePediatrico || this.item.usoPacienteNeonato)
    );
  }

  public $refs!: {
    form: HTMLFormElement;
  };

  public maxFileSize: number = 2000;
  public validTypes: string[] = PDF_MIME_TYPES;
  public file: any = null;
  public deleteFile: boolean = false;
  public subgroups: any[] = [];
  public measurementUnits: any = [];

  public calories: ICalorie[] = [];

  tpPatientLoading = false;

  @Watch('id', { immediate: true })
  public onIdChange(id) {
    if (!id) {
      this.getTpPatientConfigs();
      this.openDialog = true;
      return;
    }

    this.load();
  }

  private load(): void {
    this.loader.start('Carregando item...');
    service.getProductDetails(this.id).subscribe(
      (res) => {
        this.item = res;
        this.loader.stop();
        this.openDialog = true;
        service.getProductAlterHist(res.id).subscribe((res) => {
          this.histList = res;
        });
      },
      (error) => {
        this.loader.stop();
        this.showToastApiError(error);
        this.closeForm();
      }
    );
  }

  public onRemoveFile() {
    this.deleteFile = true;
    //this.item.urlEducativo = null;
  }

  public created() {    
    this.getCalories();
    this.getSubgroups();
    this.getMeasurementUnits();
  }

  public beforeSave() {
    if (!!this.item.id && this.item.justifAlterObrig) {
      this.dialog.show(
        'alert',
        'Alteração de produto em uso',
        '',
        'Salvar',
        (ok, just) => {
          this.saveItem(just);
        },
        'Cancelar',
        null,
        null,
        '500px',
        null,
        null,
        true,
        true,
        'Informe o motivo da alteração',
        'Motivo da alteração ...'
      );
    } else {
      this.saveItem();
    }
  }

  saveItem(just: string = null): void {
    this.$refs.form.validate();
    if (!this.form.valid) {
      return;
    }
    this.loader.start('Salvando registro...');
    let parm = this.buildParm();
    let obs = null;
    if (!this.item.id) {
      obs = service.saveProduct(parm, this.file);
    } else {
      parm.justifAlteracao = just;
      parm.deleteFile = this.deleteFile && !this.file;
      obs = service.updateProduct(parm, this.file);
    }

    obs.subscribe(
      (res) => {
        this.loader.stop();
        this.toast.show('Produto salvo com sucesso', 'success');
        this.$emit('save');
      },
      (error) => {
        this.loader.stop();
        this.showToastApiError(error);
      }
    );
  }

  buildParm() {
    let item = this.item;
    let parm = new ProdutoParmDTO();
    parm.id = item.id;
    parm.codigo = item.codigo;
    parm.descricao = item.descricao;
    parm.idSubgrupo = item.idSubgrupo;
    parm.ativo = item.ativo;

    parm.divisivelBolsas = item.divisivelBolsas;
    parm.disponibilizarNaPrescricao = item.disponibilizarNaPrescricao;
    parm.permiteAltAutomatica = item.permiteAltAutomatica;
    parm.visibilidade = item.visibilidade;
    parm.coloracao = item.coloracao;
    parm.permitePesoCalorico = item.permitePesoCalorico;

    parm.concentracao = item.concentracao;
    parm.osmolaridade = item.osmolaridade;
    parm.densidade = item.densidade;
    parm.grama = item.grama;
    parm.mmol = item.mmol;
    parm.meq = item.meq;
    parm.ui = item.ui;
    parm.idCaloria = item.idCaloria;
    parm.kcalGrama = item.kcalGrama;

    parm.usoPacienteAdulto = item.usoPacienteAdulto;
    parm.usoPacientePediatrico = item.usoPacientePediatrico;
    parm.usoPacienteNeonato = item.usoPacienteNeonato;

    parm.idsUnidadesMedidas = item.idsUnidadesMedidas;
    parm.insumos = item.insumos.map((i) => {
      let dto = new InsumoProdutoParmDTO();
      dto.idInsumo = i.idInsumo;
      dto.quantidade = i.quantidade;
      dto.quantidadeReferencia = i.quantidadeReferencia;
      return dto;
    });

    parm.tipoPacConfigs = item.tipoPacConfigs.map(c => {
      let dto = new ProdutoTipoPacConfigParmDTO();
      dto.tipoPaciente = c.tipoPaciente;
      dto.pesoMin= c.pesoMin;
      dto.pesoMax= c.pesoMax;
      dto.idadeMin = c.idadeMin;
      dto.idadeMinTipo = c.idadeMinTipo;
      dto.idadeMax= c.idadeMax;
      dto.idadeMaxTipo = c.idadeMaxTipo;
      dto.uso = c.uso;
      return dto;
    });

    return parm;
  }

  public closeForm(): void {
    const closeAction = () => {
      this.$emit('close');
    };

    this.dialog.show(
      'error',
      'Sair sem salvar',
      'Deseja sair sem salvar as alterações?',
      'Cancelar',
      '',
      'Sair',
      closeAction
    );
  }

  public checkMlDia(id: number): boolean {
    return id == ID_UNIT_ML_DIA;
  }

  private getSubgroups(): void {
    getSubgroups().subscribe(
      (data) => {
        const subgroups = [];

        data.reduce((items, item) => {
          if (!!item.grupo) {
            items.push({
              ...item,
              nome: `${item.grupo.nome} / ${item.nome}`
            });
          }
          return items;
        }, subgroups);

        this.subgroups = subgroups.sort(sortKey('nome'));
      },
      () => {
        this.toast.show('Ocorreu um erro ao carregar os subgrupos.', 'error');
      }
    );
  }

  private getMeasurementUnits() {
    serviceMeasurementUnit.listAll().subscribe((data) => {
      this.measurementUnits = data;
    });
  }

  private getCalories() {
    service.getCalories().subscribe((data) => {
      this.calories = data;
    });
  }

  public disableInput(): boolean {
    return !this.isEdit || (this.item.id && !this.item.podeAlterarTudo);
  }

  getTpPatientConfigs() {
    this.tpPatientLoading = true;
    service.getProductTpPatientConfigsOptions().subscribe(res => {
      this.item.tipoPacConfigs = res;
      this.tpPatientLoading = false;
    });
  }
}
